import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import LoginDialog from '@/venit/components/cortona-venit/components/login/LoginDialog.vue';
import AccountService from '@/account/account.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderButton',
  props: {
    disabled: { type: Boolean, default: true }
  },
  setup(__props: any) {



const router = useRouter();
const accountService = inject<() => AccountService>('accountService')!;

const showLogin = ref(false);

const goToOrder = () => {
  if (accountService().authenticated) {
    router.push({ name: 'user-order-page' });
  } else {
    showLogin.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        block: "",
        size: "large",
        color: "primary",
        variant: "flat",
        disabled: __props.disabled,
        onClick: goToOrder
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-2" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-check", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('order.execute')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(LoginDialog, {
        show: showLogin.value,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showLogin).value = $event)),
        onLoggedIn: goToOrder
      }, null, 8 /* PROPS */, ["show"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})